import { MicroFrontend } from '@praxis/component-microfrontend'
import apiConfig from '../../globalConfig/apiConfig'
import { LoadingProfileMfe } from '../common/LoadingProfileMfe' // Import Redux store
import store from '../../store'

export const IauCreateMfe = ({ ...rest }) => {
  const path = `${apiConfig.remotes.iau}/remoteEntry.js`
  return (
    <>
      <div className="dummy-header" />
      <MicroFrontend
        module="./Create"
        src={path}
        mfeProp={{ source: 'lphome' }}
        Loading={LoadingProfileMfe}
        parentStore={store}
        {...rest}
      ></MicroFrontend>
    </>
  )
}
